import { render, staticRenderFns } from "./Rnp.vue?vue&type=template&id=8f47dd52&"
import script from "./Rnp.vue?vue&type=script&lang=js&"
export * from "./Rnp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports